<!--
  This component is needed because currently is not possible to set the size
  https://github.com/vuetifyjs/vuetify/issues/20837
-->
<template>
  <v-badge
    :class="{
      'badge-rounded': badgeRounded === true || badgeRounded === 'rounded',
    }"
    v-bind="$attrs"
  >
    <!--
      Dynamically inherit slots from parent
      & make all slots from component reusable from parent
    -->
    <template v-for="(_, slot) in $slots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="{ ...scope }" />
    </template>
  </v-badge>
</template>
<script setup lang="ts">
const props = defineProps({
  size: {
    type: Number,
    default: 12,
  },
  sizeFont: {
    type: Number,
    default: undefined,
  },
  badgeRounded: {
    type: String as PropType<boolean | 'rounded'>,
    default: undefined,
  },
})

const computedSize = computed(() => `${props.size}px`)
const computedFontSize = computed(
  () => `${props.sizeFont ? props.sizeFont : props.size - 3}px`,
)
</script>

<style scoped lang="scss">
:deep(.v-badge__badge) {
  font-size: v-bind(computedFontSize);
  padding: 0 3px;
}

.badge-rounded {
  :deep(.v-badge__badge) {
    height: v-bind(computedSize);
    width: v-bind(computedSize);
    min-width: auto;
  }
}
</style>
